import { FC, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';

import { Button, Divider, Stack, Tabs, Tab } from '@mui/material';

import { FormCard, FormRoot, Page, PageHeader, SideModal } from '@/components';
import { SideModalTitle } from '@/features/properties/components/sidemodal-content/SideModalTitle';
import { withLoader, WithLoaderProps } from '@/hocs';
import { TowingCompanyTable } from '@/pages/Tools/TowingManagement/Tables/TowingCompanyTable';
import { TowingRecordsTable } from '@/pages/Tools/TowingManagement/Tables/TowingRecordsTable';

const TAB_PARAM_MAP: Record<string, number> = {
  companies: 0,
  records: 1,
};

const TAB_INDEX_MAP: Record<number, string> = {
  0: 'companies',
  1: 'records',
};

const TowingManagement: FC<WithLoaderProps> = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [page, setPage] = useState<number>(1);
  const [open, setOpen] = useState<boolean>(false);

  const tabParam = searchParams.get('tab') || 'companies';
  const selectedTab = TAB_PARAM_MAP[tabParam] ?? 0;

  const methods = useForm<any>({
    mode: 'all',
  });

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setSearchParams({ tab: TAB_INDEX_MAP[newValue] });
  };

  return (
    <Page title="Towing Management">
      <PageHeader title="Towing Management" backRoute="/tools" />

      <SideModal open={open} onClose={() => setOpen(false)}>
        <>
          <Stack sx={{ p: 2, pt: 0 }}>
            <SideModalTitle>Create BOLO</SideModalTitle>
          </Stack>
          <FormProvider {...methods}>
            <FormRoot onSubmit={() => {}}>
              <FormCard title="BOLO details">
                {/* Form fields go here */}
              </FormCard>
            </FormRoot>

            <Stack sx={{ p: 2, marginTop: 'auto' }}>
              <Divider sx={{ my: 3, width: '100%' }} />
              <Stack flexDirection="row" justifyContent="flex-end">
                <Button
                  variant="outlined"
                  color="inherit"
                  onClick={() => setOpen(false)}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="error"
                  sx={{ ml: 3, px: 2 }}
                >
                  Create
                </Button>
              </Stack>
            </Stack>
          </FormProvider>
        </>
      </SideModal>

      <Tabs value={selectedTab} onChange={handleTabChange} sx={{ mb: 2 }}>
        <Tab label="Towing Companies" sx={{ marginRight: 2 }} />
        <Tab label="Tow Records" />
      </Tabs>

      {selectedTab === 0 && <TowingCompanyTable />}

      {selectedTab === 1 && (
        <TowingRecordsTable page={page} onChangePage={setPage} />
      )}
    </Page>
  );
};

export default withLoader(TowingManagement);
